import { mergePropsClassName } from '@liquorice/allsorts-craftcms-nextjs';
import { isArray } from 'lodash';
import Txt, { TxtProps } from '../ui/Txt';
import * as style from './Card.css';
import { useCard } from './useCard';

export type CardPhoneProps<D extends React.ElementType = 'p'> = TxtProps<D>;

export const CardPhone = <D extends React.ElementType>({
  children,
  ...props
}: CardPhoneProps<D>) => {
  const { phone } = useCard();
  const content = children ?? phone;

  const hasContent = !!content && (!isArray(content) || content.length);

  return hasContent ? (
    <Txt as="span" color="black" {...mergePropsClassName(props, style.phone)}>
      {content}
    </Txt>
  ) : null;
};
